angular.module('leftPaneModule')
  .controller('LeftPaneClassroomController', [
      '$scope', '$rootScope', '$state', 'classroomApi', 'cancelableResourceManager',
      'authentication', 'edxReportItemService', 'timeframe'
      , function (
          $scope, $rootScope, $state, $classroomApi, $cancelableResourceManager,
          dblAuthentication, edxReportItemService, timeframe
      ) {

      $scope.showPercents = true;

      var updateClassroomData = function () {
          var promise = $classroomApi.getClassroomData($scope.item.id, function (classroomData) {
              $scope.classroomData = classroomData;
              timeframe.getYearListSubject().onNext(classroomData.years);
              // deprecated: use timeframe.getYearListSubject
              $rootScope.$broadcast('updateYears', classroomData.years);
          });
          $cancelableResourceManager.add(promise);
      };

      var initializeData = function (item) {
          $scope.item = item;

          $scope.viewType = dblAuthentication.growthAsFraction()  ? 'fractionMode' : 'percentMode';

          updateClassroomData();
      };

      var itemSubscription = edxReportItemService.getCurrentItemObservable().subscribe(initializeData);

      var initializeItemSettings = function (e, settingsItem) {
          $scope.classroomSettings = settingsItem;
      };
      $scope.$on('settingsItemReady', initializeItemSettings);
      $scope.$on('$destroy', function () {
          itemSubscription.dispose();
      });

  }]);
